import apiService from '../apiService'
import Notification from '../notification'

export default {
  data: () => {
    return {
      publications: {
        list: [],
        total: 0,
        fetching: true
      }
    }
  },
  computed: {
    publicationsNotEmpty () {
      return !!Object.keys(this.publications.list).length
    },
    publicationsSorted () {
      const list = Object.values(this.publications.list)
      list.sort((a, b) => {
        if (a.ID > b.ID) {
          return -1
        }

        if (a.ID < b.ID) {
          return 1
        }

        return 0
      })

      return list
    }
  },
  methods: {
    fetchPublications (type, page, perPage, sectionId) {
      this.publications.fetching = true

      apiService.getPublications(type, page, perPage, sectionId)
        .then(response => {
          this.publications.list = response.data.DATA
          this.publications.total = response.data.COUNT_ALL
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список публикаций.'
          })
        })
        .finally(() => {
          this.publications.fetching = false
        })
    }
  }
}
